module.exports = __webpack_public_path__ + "img/smart_appliance_pairing_mode.4e21a4cc.png";